import { PageLayout } from 'layouts';

export const ApiMappings = () => {
  return <PageLayout>ApiMappings Page</PageLayout>;
};
